// ======================================================================
// File Name       : EmailConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const RESERVED_FLAG = {
  IMMEDIATE: 0,
  RESERVATION: 1,
};

export const EMAIL_TYPE = {
  IMMEDIATE_TRANSMISSION: 0,
  RESERVATION: 1,
  IMMEDIATE_COURSE_INCOMPLETE_NOTIFICATION: 2,
  RESERVETION_COURSE_INCOMPLE_NOTIFICATION: 3,
  ACCOUNT_INFORMATION_NOTIFICATION: 4,
};

export const MAIL_SEND_STATUS = {
  WAITING: 0,
  DELIVERED: 1,
  CANCELED: 2,
  UNKNOWN_DESTINATION: 3,
  ERROR_BLACK_LIST: 4,
  FAILED: 5,
  RESERVED: 6,
};

export const MAIL_SEND_STATUS_TYPE = {
  SUCCESS: 1,
  FAILED: 2,
};

export const mailSendStatusType = [
  { name: '送信待ち/送信不能', value: 0 },
  { name: '送信済み ', value: 1 },
  { name: '送信キャンセル', value: 2 },
  { name: '送信先不明', value: 3 },
  { name: '送信エラー', value: 4 },
  { name: '送信エラー ', value: 5 },
  { name: '予約中', value: 6 },
];

export const MAIL_EDIT_TYPE = {
  REGISTER: 0,
  EDIT: 1,
  DELETE: 2,
};

export const EMAIL_SENDING_STATUS_NOTE = `※ 送信結果が送信待ち/送信不能から変わらない場合は、ユーザーに設定されているメールアドレスが間違っている可能性があります。
  ご確認のうえ、再度メール送信をお願いします。`;

